import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Collapse from '@material-ui/core/Collapse';
import Link from '@material-ui/core/Link';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import { withCookies } from 'react-cookie'
import * as Constants from '../constants'

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    position: 'absolute',
    width: '550px',
    height: '600px',
    left: 'calc((100% - 50px - 550px) / 2)',
    top: 'calc((100% + 30px - 600px) / 2)',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    padding: theme.spacing(0.5),
  },
});

class LogInDialog extends React.Component {
  state = {
    loading: false,
    stay_signed_in: true,
    selected_tab: 0,
    dialog_height: 300,
    snackbar_open: false,

    email_login: "",
    pw_login: "",
    polite_form: "",
    first_name: "",
    last_name: "",
    email_register: "",
    tel_register: "",
    pw_register: "",
    pw_register_repeat: "",
    zip_code: "88433",
    city: "",
    address: "",

    error_email_login: false,
    error_pw_login: false,
    error_polite_form: false,
    error_first_name: false,
    error_last_name: false,
    error_email_register: false,
    error_tel_register: false,
    error_pw_register: false,
    error_pw_register_repeat: false,
    error_zip_code: false,
    error_city: false,
    error_correction_check: false,
    error_agb: false,

    correction_check: false,
    agb: false,
    image_permission: false
  }

  constructor(props) {
    super(props)

    this.state.stay_signed_in = !props.admin;
  }

  handleTabChange = (event, value) => {
    this.setState({ selected_tab: value });
  };

  handleTabChangeIndex = index => {
    this.setState({ selected_tab: index });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value, ["error_" + name]: false });
  };

  handleClickShowPassword = (event) => {
    this.setState({ showPassword: !this.state.showPassword });
  }

  clickStaySignedIn = (event) => {
    this.setState({ stay_signed_in: !this.state.stay_signed_in });
  }

  clickCorrectionCheck = (event) => {
    this.setState({ correction_check: !this.state.correction_check, error_correction_check: false });
  }

  clickAGB = (event) => {
    this.setState({ agb: !this.state.agb, error_agb: false });
  }

  clickImagePermission = (event) => {
    this.setState({ image_permission: !this.state.image_permission, error_image_permission: false });
  }

  onEnterPressed = (ev) => {
    if (ev.key === 'Enter') {
      this.onLoginRegister();
      ev.preventDefault();
    }
  }

  onReset = () => {
    //Formular zurücksetzen
    if (this.state.selected_tab === 0) {
      this.setState({ email_login: "", pw_login: "", stay_signed_in: true, loading: false });
    } else if(this.state.selected_tab === 1) {
      this.setState({ email_register: "", tel_register: "", pw_register: "", pw_register_repeat: "", stay_signed_in: true, polite_form: "", first_name: "", last_name: "", zip_code: "88433", city: "", address: "", correction_check: false, agb: false, image_permission: false, loading: false });
    }
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false, snackbar_success_open: false });
  }

  forgotPassword = () => {
    if (this.state.email_login.length > 0 && this.state.email_login !== "admin") {
      let currentComponent = this;
      request.post(Constants.BACKEND_URL)
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('accept', 'json')
        .send({ command: (this.props.leader ? "resetpasswordleader" : "resetpassword"), email: this.state.email_login })
        .timeout({
          deadline: 500
        })
        .end((err, res) => {
          if (err?.timeout) {
            currentComponent.setState({ snackbar_success_open: true, snackbar_message: "Prüfen Sie Ihr E-Mail-Postfach. Evt. auch im Spam-Ordner.", loading: false });
          } else {
            var result = res.text.trim();
            if (result === "1") {
              currentComponent.setState({ snackbar_success_open: true, snackbar_message: "Prüfen Sie Ihr E-Mail-Postfach. Evt. auch im Spam-Ordner.", loading: false });
            } else {
              currentComponent.setState({ snackbar_open: true, snackbar_message: "Die Kombination aus E-Mail Adresse und Passwort ist unbekannt.", loading: false });
            }
          }
        });
    } else {
      this.setState({ snackbar_open: true, snackbar_message: "Bitte tragen Sie im vorgesehenen Feld Ihre E-Mail Adresse ein.", loading: false });
    }
  }

  onLoginRegister = () => {
    this.setState({ loading: true });
    if (this.state.selected_tab === 0) {
      //Anmelden
      if (this.state.email_login !== "" && this.state.pw_login !== "") {
        //Alles ist ausgefüllt
        let sha1 = require('sha1');
        let password = sha1(this.state.pw_login);
        let currentComponent = this;
        let command = "login";
        if (this.props.leader) {
          command = "leaderlogin";
        } else if (this.props.admin) {
          command = "adminlogin";
        }
        request.post(Constants.BACKEND_URL)
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('accept', 'json')
          .send({ command, email: this.state.email_login, pw: password })
          .end((err, res) => {
            var result = res.text.trim();
            if (result !== "0") {
              var obj = JSON.parse(result)[0];
              if (this.props.leader) obj.role = "leader";
              if (obj.role !== "activating") {
                if (currentComponent.state.stay_signed_in && !currentComponent.props.admin && !currentComponent.props.leader) this.props.cookies.set('staySignedIn', { email: currentComponent.state.email_login, pw: password })
                obj.pw = password;
                obj.email = currentComponent.state.email_login;
                currentComponent.props.onSignedIn(obj);
                currentComponent.onReset();
              } else {
                currentComponent.setState({ snackbar_open: true, snackbar_message: "Der Account wurde noch nicht aktiviert. Bitte überprüfen Sie Ihr E-Mail Postfach.", loading: false });
              }
            } else {
              currentComponent.setState({ snackbar_open: true, snackbar_message: "Nutzername oder Passwort falsch.", pw_login: "", loading: false });
            }
          });
      } else {
        //Etwas ist nicht ausgefüllt
        this.setState({ error_email_login: this.state.email_login === "", error_pw_login: this.state.pw_login === "", loading: false });
      }
    } else if (this.state.selected_tab === 1) {
      //Registrieren
      if (this.state.polite_form !== "" && this.state.first_name !== "" && this.state.last_name !== "" && this.state.email_register !== "" && this.state.tel_register !== "" && this.state.pw_register !== "" && this.state.pw_register_repeat !== "" && this.state.zip_code !== "" && this.state.city !== "" && this.state.correction_check === true && this.state.agb === true && this.state.image_permission === true) {
        //Alles ist ausgefüllt
        if (this.isValidEmail(this.state.email_register)) {
          //Gültige E-Mail Adresse
          if (this.state.pw_register === this.state.pw_register_repeat) {
            //Passwörter stimmen überein
            let sha1 = require('sha1');
            let password = sha1(this.state.pw_register);

            let currentComponent = this;
            request.post(Constants.BACKEND_URL)
              .set('Content-Type', 'application/x-www-form-urlencoded')
              .send({ command: "newaccount", polite_form: this.state.polite_form, first_name: this.state.first_name, last_name: this.state.last_name, email: this.state.email_register, tel: this.state.tel_register.replace(" / ", " ").replace("/", " "), pw: password, zip: this.state.zip_code, city: this.state.city, address: this.state.address, photo_permission: this.state.image_permission })
              .end(function (err, res) {
                var result = res.text.trim();
                if (result === "1") {
                  currentComponent.onReset();
                  currentComponent.setState({ snackbar_success_open: true, snackbar_message: "Überprüfen Sie Ihr E-Mail Postfach. Evtl. auch den Spam-Ordner", email_login: currentComponent.state.email_register, selected_tab: 0, loading: false });
                } else {
                  currentComponent.setState({ error_email_register: true, snackbar_open: true, snackbar_message: "Es ist bereits jemand anderes mit dieser E-Mail Adresse registriert", loading: false });
                }
              });
          } else {
            //Passwörter stimmen nicht überein
            this.setState({ error_pw_register: true, error_pw_register_repeat: true, pw_register_repeat: "" });
          }
        } else {
          //E-Mail ist nicht gültig
          this.setState({ error_email_register: true, loading: false });
        }
      } else {
        //Etwas ist nicht ausgefüllt
        this.setState({ error_polite_form: this.state.polite_form === "", error_first_name: this.state.first_name === "", error_last_name: this.state.last_name === "", error_email_register: this.state.email_register === "", error_tel_register: this.state.tel_register === "y", error_pw_register: this.state.pw_register === "", error_pw_register_repeat: this.state.pw_register_repeat === "", error_zip_code: this.state.zip_code === "", error_city: this.state.city === "", error_correction_check: !this.state.correction_check, error_agb: !this.state.agb, error_image_permission: !this.state.image_permission, loading: false });
      }
    }
  }

  isValidEmail(email) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  addParent = id => {
    this.setState({ parent_id: id });
  }

  render() {
    const { classes, theme, fullScreen } = this.props;

    return (
      <Dialog fullScreen={fullScreen} open={this.props.open} aria-labelledby="responsive-dialog-title" BackdropProps={{ style: { backgroundColor: "transparent" } }}>
        <DialogContent style={{ padding: 0 }}>
          <Collapse in={this.state.selected_tab} collapsedSize="200px">
            <Tabs value={this.state.selected_tab} onChange={this.handleTabChange} indicatorColor="primary" textColor="primary" variant="fullWidth" >
              <Tab label={this.props.leader ? "Als Leiter anmelden" : "Anmelden"} />
              <Tab label={this.props.leader ? "Als Leiter registrieren" : "Registrieren"} />
            </Tabs>
            <SwipeableViews axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'} index={this.state.selected_tab} onChangeIndex={this.handleTabChangeIndex}>
              {/* Login-Tab */}
              <div dir={theme.direction} style={{ padding: 20 }}>
                <DialogContentText>Geben Sie unten Ihre Anmeldedaten ein.</DialogContentText>
                {/* E-Mail */}
                <TextField label="E-Mail Adresse" value={this.state.email_login} onKeyPress={this.onEnterPressed} onChange={this.handleChange('email_login')} style={{ width: "49%", marginTop: 10, marginRight: "2%" }} type="email" error={this.state.error_email_login} />
                {/* Passwort */}
                <FormControl style={{ width: "49%", marginTop: 10 }}>
                  <InputLabel htmlFor="password">Passwort</InputLabel>
                  <Input
                    label="Passwort"
                    value={this.state.pw_login}
                    onChange={this.handleChange('pw_login')}
                    type={this.state.showPassword ? 'text' : 'password'}
                    error={this.state.error_pw_login}
                    onKeyPress={this.onEnterPressed}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton onClick={this.handleClickShowPassword}>{this.state.showPassword ? <Visibility /> : <VisibilityOff />}</IconButton>
                      </InputAdornment>
                    } />
                </FormControl>
                {!this.props.admin && !this.props.leader && <FormControlLabel control={<Checkbox checked={this.state.stay_signed_in} onChange={this.clickStaySignedIn} />} label="Angemeldet bleiben" />}
                <Link component="button" style={{ marginRight: (this.props.admin || this.props.leader ? 285 : 110) }} onClick={this.forgotPassword}>Passwort vergessen</Link>
              </div>
              {/* Register-Tab */}
              <div dir={theme.direction} style={{ padding: 20 }}>
                {this.props.leader && this.props.serverSettings.state === 6 && <DialogContentText>Sie haben noch keinen Leiter-Account? Bitte setzen Sie sich mit dem Rathaus Schemmerhofen in Verbindung. Zuständig sind Frau Blersch Tel.: 07356 9356-29, E-Mail: <a href="mailto:susanne.blersch@schemmerhofen.de">susanne.blersch@schemmerhofen.de</a> oder Frau Moll Tel.:07356 9356-54, E-Mail <a href="mailto:sabine.moll@schemmerhofen.de">sabine.moll@schemmerhofen.de</a>.</DialogContentText>}
                {this.props.leader && this.props.serverSettings.state < 6 && <DialogContentText>Leiter-Accounts können nur während der Anmeldephase für Leiter erstellt werden. Leider ist diese für dieses Jahr bereits vorüber. Bitte versuchen Sie es im nächsten Jahr noch einmal.</DialogContentText>}
                {!this.props.leader && <DialogContentText>{this.props.serverSettings.state < 5 ? "Sie haben noch keinen Account? Geben Sie unten Ihre Daten ein." : "Sie können nur in der Anmeldephase Nutzerkonten erstellen."}</DialogContentText>}
                {/* Anrede */}
                {!this.props.leader && this.props.serverSettings.state < 5 && <div>
                  <FormControl style={{ width: 100, marginRight: 10 }} error={this.state.error_polite_form}>
                    <InputLabel htmlFor="pf" shrink={this.state.polite_form !== ""} required>Anrede</InputLabel>
                    <Select value={this.state.polite_form} onChange={this.handleChange('polite_form')} inputProps={{ id: 'pf' }}>
                      <MenuItem value=""><em>Auswählen</em></MenuItem>
                      <MenuItem value={1}>Frau</MenuItem>
                      <MenuItem value={2}>Herr</MenuItem>
                    </Select>
                  </FormControl>
                  {/* Vorname */}
                  <TextField label="Vorname" value={this.state.first_name} onChange={this.handleChange('first_name')} onKeyPress={this.onEnterPressed} style={{ width: "calc((100% - 100px) / 2 - 10px)", marginRight: 10 }} error={this.state.error_first_name} required />
                  {/* Nachname */}
                  <TextField label="Nachname" value={this.state.last_name} onChange={this.handleChange('last_name')} onKeyPress={this.onEnterPressed} style={{ width: "calc((100% - 100px) / 2 - 10px)" }} error={this.state.error_last_name} required />
                  {/* E-Mail */}
                  <TextField label="E-Mail-Adresse" value={this.state.email_register} onKeyPress={this.onEnterPressed} onChange={this.handleChange('email_register')} style={{ width: "49%", marginTop: 10, marginRight: "2%" }} type="email" error={this.state.error_email_register} required />
                  {/* Tel */}
                  <TextField label="Telefonnummer" value={this.state.tel_register} onKeyPress={this.onEnterPressed} onChange={this.handleChange('tel_register')} style={{ width: "49%", marginTop: 10 }} type="tel" error={this.state.error_tel_register} required />
                  {/* Passwort */}
                  <FormControl style={{ width: "49%", marginTop: 10, marginRight: "2%" }} required>
                    <InputLabel htmlFor="password">Passwort</InputLabel>
                    <Input
                      label="Passwort"
                      value={this.state.pw_register}
                      onChange={this.handleChange('pw_register')}
                      type={this.state.showPassword ? 'text' : 'password'}
                      error={this.state.error_pw_register}
                      onKeyPress={this.onEnterPressed} />
                  </FormControl>
                  {/* Passwort wiederholen */}
                  <FormControl style={{ width: "49%", marginTop: 10 }} required>
                    <InputLabel htmlFor="password">Passwort bestätigen</InputLabel>
                    <Input
                      label="Passwort"
                      value={this.state.pw_register_repeat}
                      onChange={this.handleChange('pw_register_repeat')}
                      onKeyPress={this.onEnterPressed}
                      type={this.state.showPassword ? 'text' : 'password'}
                      error={this.state.error_pw_register_repeat}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton onClick={this.handleClickShowPassword}>{this.state.showPassword ? <Visibility /> : <VisibilityOff />}</IconButton>
                        </InputAdornment>
                      }
                      required />
                  </FormControl>
                  {/* PLZ */}
                  <TextField label="PLZ" value={this.state.zip_code} onChange={this.handleChange('zip_code')} onKeyPress={this.onEnterPressed} style={{ width: 100, marginRight: 10, marginTop: 10 }} type="number" error={this.state.error_zip_code} required />
                  {/* Ort */}
                  <TextField label="Ort / Ortsteil" value={this.state.city} onChange={this.handleChange('city')} onKeyPress={this.onEnterPressed} style={{ width: "calc((100% - 100px) / 2 - 10px)", marginRight: 10, marginTop: 10 }} error={this.state.error_city} required />
                  {/* Adresse */}
                  <TextField label="Adresse" value={this.state.address} onChange={this.handleChange('address')} onKeyPress={this.onEnterPressed} style={{ width: "calc((100% - 100px) / 2 - 10px)", marginTop: 10 }} error={this.state.error_address}/>
                  {/* Web & Gmx warning */}
                  <Typography style={{ marginTop: 20 }}>Mit web- bzw. gmx-E-Mail-Adressen kommt es derzeit zu zeitlich verzögerten Meldungen. Bitte prüfen Sie Ihr Postfach ggf. auch den Spamordner.</Typography>
                  {/* Richtigkeit */}
                  <FormControlLabel control={<Checkbox checked={this.state.correction_check} onChange={this.clickCorrectionCheck} />} label={this.state.error_correction_check ? (<font color='red'>Ich habe meine Eingaben auf Richtigkeit geprüft.</font>) : ("Ich habe meine Eingaben auf Richtigkeit geprüft.")} />
                  {/* Datenschutz */}
                  <FormControlLabel style={{ marginTop: 10, marginBottom: 5 }} control={<Checkbox checked={this.state.agb} onChange={this.clickAGB} />} label={this.state.error_agb ? (<font color='red'>Der Schutz Ihrer Privatsphäre ist für uns sehr wichtig. In unserer Datenschutzerklärung informieren wir Sie ausführlich über die Verarbeitung der Daten von Ihnen und Ihrem Kind bei einer Anmeldung zum Ferienprogramm. Die Daten werden zur Durchführung der Veranstaltungsplanung, -zuteilung , und -durchführung benötigt. Eine Anmeldung ist deshalb nur mit Einwilligung in die Datenverarbeitung möglich. Nimmt das Kind 3 Jahre in Folge nicht mehr am Ferienprogramm teil, werden alle Daten automatisch gelöscht.</font>) : ("Der Schutz Ihrer Privatsphäre ist für uns sehr wichtig. In unserer Datenschutzerklärung informieren wir Sie ausführlich über die Verarbeitung der Daten von Ihnen und Ihrem Kind bei einer Anmeldung zum Ferienprogramm. Die Daten werden zur Durchführung der Veranstaltungsplanung, -zuteilung , und -durchführung benötigt. Eine Anmeldung ist deshalb nur mit Einwilligung in die Datenverarbeitung möglich. Nimmt das Kind 3 Jahre in Folge nicht mehr am Ferienprogramm teil, werden alle Daten automatisch gelöscht.")} />
                  <Link href="https://www.schemmerhofen.de/,Lde/Home/Gemeinde+_+Daten/Datenschutz.html" target="blank" style={{ marginLeft: 30, marginTop: 10 }}>Weitere Informationen zum Datenschutz</Link>
                  {/* Bilder */}
                  <FormControlLabel style={{ marginTop: 10, marginBottom: 5 }} control={ <Checkbox checked={this.state.image_permission} onChange={this.clickImagePermission} /> } label={this.state.error_image_permission ? (<font color='red'>Ich bestätige, dass ich mit der Veröffentlichung der bei den Veranstaltungen gemachten Fotos meines Kindes einverstanden bin. Meine Einwilligung bezieht sich auf die Vervielfältigung, Verbreitung, Ausstellung und Veröffentlichung der Aufnahmen zu Zwecken der Öffentlichkeitsarbeit durch die Institution/Veranstalter, ohne Beschränkung des sachlichen, räumlichen oder zeitlichen Verwendungsbereichs. Die Bilder können insbesondere im Rahmen von Publikationen, von Informationsbroschüren und für die Internet-Präsenz der beteiligten Organisationen verwendet werden. Fotos werden ohne personenbezogene Daten veröffentlicht.</font>) : ("Ich bestätige, dass ich mit der Veröffentlichung der bei den Veranstaltungen gemachten Fotos meines Kindes einverstanden bin. Meine Einwilligung bezieht sich auf die Vervielfältigung, Verbreitung, Ausstellung und Veröffentlichung der Aufnahmen zu Zwecken der Öffentlichkeitsarbeit durch die Institution/Veranstalter, ohne Beschränkung des sachlichen, räumlichen oder zeitlichen Verwendungsbereichs. Die Bilder können insbesondere im Rahmen von Publikationen, von Informationsbroschüren und für die Internet-Präsenz der beteiligten Organisationen verwendet werden. Fotos werden ohne personenbezogene Daten veröffentlicht.")} />
                </div>}
              </div>
            </SwipeableViews>
          </Collapse>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onHelp} variant="contained" disabled={this.state.loading}>Hilfe</Button>
          <Button onClick={this.onReset} variant="contained" disabled={this.state.loading || (this.state.selected_tab === 1 && this.props.serverSettings.state >= 5) || (this.state.selected_tab === 1 && this.props.leader)}>Formular zurücksetzen</Button>
          <Button onClick={this.onLoginRegister} variant="contained" disabled={this.state.loading || (this.state.selected_tab === 1 && this.props.serverSettings.state >= 5) || (this.state.selected_tab === 1 && this.props.leader)} color="primary" autoFocus>
            {this.state.selected_tab === 0 ? (this.props.leader ? "Als Leiter anmelden" : "Anmelden") : "Account erstellen"}
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        {/* Success-Snackbar */}
        <Snackbar className={classes.success} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_success_open} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                {this.state.snackbar_message}
              </span>
            }
            action={[
              <IconButton color="inherit" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: green[600] }} />
        </Snackbar>
        {/* Error-Snackbar */}
        <Snackbar className={classes.error} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorIcon className={classes.icon} />
                {this.state.snackbar_message}
              </span>
            }
            action={[
              <IconButton color="inherit" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Dialog>
    );
  }
}

LogInDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onSignedIn: PropTypes.func.isRequired,
  onHelp: PropTypes.func.isRequired,
  admin: PropTypes.bool.isRequired,
  leader: PropTypes.bool.isRequired,
  serverSettings: PropTypes.object.isRequired,
};

export default withMobileDialog()(withCookies(withStyles(styles, { withTheme: true })(LogInDialog)));
